"use client";

import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroDuService() {
  const [scrollY, setScrollY] = useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxOffset = scrollY * 0.3;
  return <section ref={ref} className="relative min-h-screen w-full overflow-hidden bg-background flex items-center justify-center px-4 py-16">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-40 transition-transform duration-300 ease-out" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1520072/img/cyber_grid_animated_background.png)",
      transform: `translateY(${parallaxOffset}px)`
    }} />

      {}
      <div className={`
          relative z-10 max-w-4xl w-full
          bg-surface/80 backdrop-blur-md
          border border-muted/40 rounded-lg shadow-strong
          px-8 py-12 md:px-16 md:py-20
          text-center
          transition-all duration-500 ease-out
          ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
        `}>
        {}
        <h1 className="font-display font-bold mb-6 text-foreground drop-shadow-[0_0_12px_rgba(192,192,192,0.5)] !text-[38px]">Cybersécurité & Confiance Numerique</h1>

        {}
        <p className="text-lg md:text-2xl font-sans font-normal text-muted-foreground mb-4">Construire des offres de cybersécurité qui protègent les actifs critiques, assurent la conformité règlementaire et retablissent la confiance numérique des entreprises&nbsp;</p>

        <p className="text-base md:text-lg font-sans text-muted-foreground/90 mb-10 max-w-2xl mx-auto">La Cybersécurité au service de la performance durable.</p>

        {}
        <Link to="#contact">
          <Button size="lg" className="
              bg-primary text-foreground-primary font-semibold
              px-8 py-4 rounded-md shadow-medium
              hover:bg-primary-hover hover:scale-105
              active:bg-primary-active active:scale-100
              transition-all duration-300 ease-out
              focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring
            ">Parlons Cyber&nbsp;</Button>
        </Link>
      </div>
    </section>;
}